module.exports = __webpack_public_path__ + "nike-favicon.ico";